// extracted by mini-css-extract-plugin
export default {"card":"common-components-FullscreenCard-FullscreenCard__card--eHjS0"};